import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Row, Col, Form } from "react-bootstrap";

import Modal from "../../modal";
import { isGuid } from "../../../utils/string";

class AvailabilityCopyModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.mapPropsToState(props);
    }

    mapPropsToState = (props) => ({
        personUuid: props.personUuid ?? null,
        roleUuid: props.roleUuid ?? null,
        sourceDate: props.sourceDate ?? "",
        targetDatesRaw: Array.isArray(props.targetDates) ? props.targetDates.join(", ") : "",
    });

    componentDidUpdate(prevProps) {
        if ((!prevProps.show && this.props.show) || prevProps.sourceDate !== this.props.sourceDate) {
            this.setState(this.mapPropsToState(this.props));
        }
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    parseDates = () => {
        return String(this.state.targetDatesRaw || "")
            .split(",")
            .map((x) => x.trim())
            .filter(Boolean)
            .filter((x) => /^\d{4}-\d{2}-\d{2}$/.test(x));
    };

    isSavable = () => {
        return (
            isGuid(this.state.personUuid) &&
            isGuid(this.state.roleUuid) &&
            /^\d{4}-\d{2}-\d{2}$/.test(String(this.state.sourceDate || "")) &&
            this.parseDates().length > 0
        );
    };

    buildPayload = () => ({
        personUuid: this.state.personUuid,
        roleUuid: this.state.roleUuid,
        sourceDate: this.state.sourceDate,
        targetDates: this.parseDates(),
    });

    onOk = () => this.props.onOk?.(this.buildPayload());
    onCancel = () => this.props.onCancel?.();

    render() {
        return (
            <Modal
                show={this.props.show}
                title="Copy Availability"
                size={this.props.size || "md"}
                buttons={[
                    {
                        caption: "ok",
                        onEnabledClick: this.onOk,
                        variant: "primary",
                        enabled: this.isSavable(),
                        display: true,
                    },
                    {
                        default: true,
                        caption: "cancel",
                        onEnabledClick: this.onCancel,
                        variant: "secondary",
                        enabled: true,
                        display: true,
                    },
                ]}
            >
                <Row className="g-0 mb-3">
                    <Col>
                        <div className="mb-3 top-label">
                            <Form.Control
                                type="text"
                                value={this.state.sourceDate || ""}
                                disabled
                                readOnly
                            />
                            <Form.Label>SOURCE DATE</Form.Label>
                        </div>
                    </Col>
                </Row>

                <Row className="g-0">
                    <Col>
                        <div className="mb-3 top-label">
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="targetDatesRaw"
                                value={this.state.targetDatesRaw}
                                onChange={this.onChange}
                                placeholder="2026-04-25, 2026-04-26, 2026-04-28"
                            />
                            <Form.Label>TARGET DATES (comma-separated YYYY-MM-DD)</Form.Label>
                        </div>
                    </Col>
                </Row>
            </Modal>
        );
    }
}

AvailabilityCopyModal.propTypes = {
    show: PropTypes.bool,
    personUuid: PropTypes.string,
    roleUuid: PropTypes.string,
    sourceDate: PropTypes.string,
    targetDates: PropTypes.array,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
};

export default connect()(AvailabilityCopyModal);